import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-neutral-100" data-id="element-124" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-125" data-mp="223eppxd7zv99">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-neutral-200 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg shadow-neutral-900/5" data-id="element-126" data-mp="2223jzs07sdfi">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-red-700" data-id="element-127" data-mp="1j4ty847f2nv3" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-amber-100 border-2 border-amber-500 text-neutral-900 mb-8" data-id="element-128" data-mp="1edbwhdxkkj92">
            <ShieldCheck size={48} data-id="element-129" data-mp="qm6i737a1z0v" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-neutral-900 uppercase" data-id="element-130" data-mp="lpy8w6frh01m">
            7-Day Guarantee
          </h2>
          <div className="space-y-6 text-lg text-neutral-800 max-w-2xl mx-auto" data-id="element-131" data-mp="oxfb4c17yttm">
            <p data-id="element-132" data-mp="tx1oqmkymc2y">
              Your purchase includes a 7-day guarantee for material that is not delivered, is
              incorrect, incomplete, defective or materially different from what was advertised.
            </p>
            <p className="font-medium text-neutral-900" data-id="element-133" data-mp="12t0y6dnw73je">
              If you experience an eligible issue, contact our support team within the guarantee
              period so we can review and resolve your case according to the applicable guarantee
              terms.
            </p>
            <p className="text-sm text-neutral-800/60 mt-8" data-id="element-134" data-mp="f00wmhyuwf3y">The product is delivered digitally.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}